import React, { useEffect, useState } from 'react';
import styles from './questionAnswers.css';
import {
    BULLET_LIST_TYPE,
    LETTER_LIST_TYPE,
    NUMBER_LIST_TYPE
} from '../../../../../../../../pages/manager/pages/quizPage/editor/components/preview/components/questionsPreview/components/textQuestion/components/answers/constants';
import OptionIcon
    from '../../../../../../../../pages/manager/pages/quizPage/editor/components/preview/components/questionsPreview/components/textQuestion/components/answers/components/optionIcon/OptionIcon';
import { Scrollbars } from 'react-custom-scrollbars';

/**
 *
 * @type {React.NamedExoticComponent<{readonly handleAnswerSelection?: *, readonly setEventSound?: *, readonly answers?: *, readonly contentColor?: *, readonly question?: *, readonly statistics?: *}>}
 */
const QuestionAnswers = React.memo( ( { question, answers, statistics, handleAnswerSelection, setEventSound, contentColor } ) => {
    const { localization } = question;
    const [ clickId, setClickId ] = useState( null );
    const [ correctAnswerStatus, setCorrectAnswerStatus ] = useState( null );

    useEffect( () => {
        setCorrectAnswerStatus( statistics && statistics.question_statistics && statistics.question_statistics.answered_correctly );
    }, [ statistics ] );

    const setSound = () => setEventSound( { events: 'hover' } );

    const bulletType = question.list_type === BULLET_LIST_TYPE;
    const numberType = question.list_type === NUMBER_LIST_TYPE;
    const letterType = question.list_type === LETTER_LIST_TYPE;

    let elmW = window.innerWidth > 420;

    const getElementStyle = ( answer, i ) => {

        if (   i === clickId ) {
            if ( correctAnswerStatus === true ) {
                return { 'backgroundColor': '#4c7e14' };
            }
            if ( correctAnswerStatus === false ) {
                return { 'backgroundColor': 'rgba(230, 106, 29, 0.5)' };
            }
        } else {
            if ( i === clickId ) {
                if ( correctAnswerStatus === false ) {
                    return { 'backgroundColor': 'rgba(230, 106, 29, 0.5)' };
                }
            }
            return { 'backgroundColor': contentColor.type == 'dark' ? 'rgba(0, 0, 0, 0.2)' : '#404040' };
        }
    };


    return (
        <div className={ styles.wrapper }>
            <Scrollbars
                className={ styles.scroll }
                autoHide={ true }
                autoHideTimeout={ 1000 }
                autoHideDuration={ 200 }
                thumbMinSize={ 30 }
                universal={ true }
                renderTrackHorizontal={ props => <div { ...props } className={ styles.trackHorizontal }/> }
                renderTrackVertical={ props => <div { ...props } className={ styles.trackVertical }/> }
                renderThumbHorizontal={ props => <div { ...props } className={ styles.thumbHorizontal }/> }
                renderThumbVertical={ props => <div { ...props } className={ styles.thumbVertical }/> }
                renderView={ props => <div { ...props } style={ {
                    position: 'absolute',
                    top: elmW ? '2rem' : '4rem',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    overflowY: 'auto',
                    overflowX: 'hidden',

                } }/> }>
                <div className={ styles.itemListWrap }>{
                    answers.map( ( item, i ) => {
                        const answer = item;
                        return ( <div
                            className={ styles.questionWrap }
                            key={ i }
                            onMouseDown={ () => {
                                setClickId( i );
                            } }
                            onMouseEnter={ setSound }
                            onClick={
                                () => {
                                    setClickId( i );
                                    handleAnswerSelection( {
                                    question_localization_id: localization.id,
                                    id: answer.id,
                                    user_answer: answer.id,
                                    type: localization.answer_model
                                } );}
                            }>
                            <div key={ i } className={ styles.optionIconWrapper }>
                                <OptionIcon
                                    keyNumber={ i }
                                    bulletType={ bulletType }
                                    numberType={ numberType }
                                    letterType={ letterType }
                                    themeType={ contentColor.type }
                                    elementStyle={ getElementStyle(answer, i) }/>
                            </div>
                            <p className={ styles.question }>{ answer.text }</p>
                        </div> );
                    } )
                }
                </div>
            </Scrollbars>
        </div>
    );
} );

export default QuestionAnswers;
